import { OverlayTrigger, Popover, Table, Tooltip } from 'react-bootstrap';
import { BsQuestionCircle, BsListUl } from 'react-icons/bs';
import CountdownTimer from './gameTime';
import { constant, table } from '@/utils/constant';
import { FaBell } from 'react-icons/fa';

function GroupTable({
	summaryData,
	isGameComplete,
	sessionData,
	teamData,
	isPracticeRun,
}) {
	const commonClassName = !isGameComplete ? 'text-light-gray' : '';
	const toNumberOrZero = value => {
		const num = Number(value);
		return Number.isFinite(num) ? num : 0;
	};

	const getRoundLabel = round => {
		const day = round === 13 ? 'Midnight' : round > 13 ? 'Saturday' : 'Fri';
		const time = [0, 1].includes(round)
			? 'Noon'
			: round === 13
				? ''
				: `${round - (round >= 14 ? 13 : 1)}${round >= 13 ? ' AM' : ' PM'}`;
		return `${day} ${time}`.trim();
	};

	const renderTooltip = props => (
		<Tooltip
			className='tooltip-light'
			id='button-tooltip'
			{...props}
		>
			{constant?.groupBehaviorTool}
		</Tooltip>
	);
	return (
		<div className='table-responsive group-table'>
			<Table
				bordered
				className='position-relative'
			>
				<thead>
					<tr className='text-center'>
						<th
							className='text-start'
							rowSpan={2}
						>
							{constant.teams}
						</th>
						<th rowSpan={2}>
							{table?.time} <br />
							{table?.remaining}
						</th>
						<th rowSpan={2}>
							{table?.simulated} <br />
							{table?.hour}
						</th>
						<th
							colSpan={3}
							className='py-1'
						>
							{table?.behaviorIndicators}
							<OverlayTrigger
								placement='bottom-start'
								delay={{ show: 250, hide: 400 }}
								overlay={renderTooltip}
							>
								<span>
									{' '}
									<BsQuestionCircle className='ms-2' />{' '}
								</span>
							</OverlayTrigger>
						</th>
						{!isPracticeRun && (
							<th rowSpan={2}>{table?.activity}</th>
						)}
						{!isPracticeRun && (
							<th rowSpan={2}>
								{table?.quality} <br /> {table?.loss}
							</th>
						)}
						{!isPracticeRun && (
							<th rowSpan={2}>{table?.cost}</th>
						)}
						{!isPracticeRun && (
							<th rowSpan={2}>
								{table?.blended} <br /> {table?.score}
							</th>
						)}
					</tr>
					<tr className='border-bottom border-2 text-center'>
						<th className='py-1'>{table?.collaborative}</th>
						<th className='py-1'>{table?.innovative}</th>
						<th className='py-1'>{table?.dataDriven}</th>
					</tr>
				</thead>
				<tbody className='position-relative text-center'>
					{teamData?.map((item, index) => {
						const row =
							summaryData?.find(
								(r) => Number(r.team_id) === Number(item?.id)
							) ?? summaryData?.[index];
						const activity = row?.activity ?? {};
						const teamQualityError = toNumberOrZero(row?.team_quality_error);
						const teamCost = toNumberOrZero(row?.team_cost);
						const blendedScore =
							row?.blended_score != null ? Number(row.blended_score) : null;
						const commonActivity = [
							{
								name: constant?.ambulanceDiversions,
								value: activity?.ambulanceDiversionsActivity ?? 0,
							},
							{
								name: constant?.patientsInWaiting,
								value: activity?.patientsWaitingActivity ?? 0,
							},
							{
								name: constant?.arrivalsWaiting,
								value: activity?.arrivalsWaitingActivity ?? 0,
							},
							{
								name: constant?.requestsWaiting,
								value: activity?.requestWaitingActivity ?? 0,
							},
							{
								name: constant?.extraStaff,
								value: activity?.extraStaffActivity ?? 0,
							},
						];
						const popover = (
							<Popover
								id='popover-basic'
								className='w-full'
								style={{ maxWidth: '237px' }}
							>
								<Popover.Body>
									{commonActivity?.map(activityItem => (
										<div
											key={activityItem.name}
											className='d-flex py-1'
										>
											<span>{activityItem.name}</span>
											<span className='ms-auto'>{activityItem.value}</span>
										</div>
									))}
								</Popover.Body>
							</Popover>
						);
						const array = teamData && teamData[index]?.participant;
						const hasHelpCallForFacilitator = array?.some(
							item => item.is_help_call_for_facilitator
						);

						const fallbackRound = row?.no_of_hours_not_complete;
						const currentRound =
							item?.current_round === 0 || item?.current_status === 0
								? (fallbackRound ?? 0)
								: (item?.current_round ?? 0);

						return (
							<tr key={item?.id ?? index}>
								<td
									className={`text-start ${
										hasHelpCallForFacilitator
											? 'text-parpal bg-parpal-pulse'
											: ''
									}`}
								>
									{hasHelpCallForFacilitator && (
										<FaBell
											className='circle pulse me-2 mb-1'
											style={{ height: '17px', width: '15px' }}
										/>
									)}
									Team {item?.team_index}:{' '}
									{item?.name && item?.name.length > 25
										? `${item?.name.slice(0, 25)}...`
										: item?.name}
								</td>
								<td>
									<CountdownTimer
										time={sessionData?.session?.game_start_time}
										complete={item?.is_game_complete === 1 ? true : false}
										timeToShow={
											sessionData?.session?.is_practice_run ? 1815 : 3615
										}
										teamData={item}
										sessionData={sessionData?.session}
										currentRound={currentRound}
									/>
								</td>
								<td>
									{item?.current_status > 3
										? getRoundLabel(currentRound)
										: currentRound
											? getRoundLabel(currentRound)
											: '-'}
								</td>
								{index === 0 && (
									<td
										className='text-center'
										rowSpan={teamData?.length}
										colSpan='3'
									>
										{table?.comingSoon}
									</td>
								)}
								{!isPracticeRun && (
									<td className='text-center position-relative'>
										<OverlayTrigger
											trigger='click'
											placement='bottom-start'
											overlay={popover}
											rootClose={true}
										>
											<span>
												<BsListUl className='text-lg' />
											</span>
										</OverlayTrigger>
									</td>
								)}
								{!isPracticeRun && (
									<td className={commonClassName}>
										{teamQualityError.toLocaleString('en-en')}
									</td>
								)}
								{!isPracticeRun && (
									<td className={commonClassName}>
										${teamCost.toLocaleString('en-en')}
									</td>
								)}
								{!isPracticeRun && (
									<td className={commonClassName}>
										{blendedScore != null
											? Number(blendedScore).toFixed(2)
											: '-'}
									</td>
								)}
							</tr>
						);
					})}
				</tbody>
			</Table>
		</div>
	);
}
export default GroupTable;
